import * as Utils from '@/utils'

const mutations = {
  updateReqLog(state, value) {
    state.reqLog = value
  },
  updateGlobalCompId(state, value) {
    localStorage.setItem('globalCompId', value)
    state.globalCompId = value
  },
  updateGlobalCompIdDDList(state, list) {
    state.globalCompIdDDList = Utils.toListWapper(list, {valueField: 'compId', descrField: 'compName'}) || []
  },
  updateProjSettleDtNumList(state, value) {
    state.projSettleDtNumList = value
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js